import { render, staticRenderFns } from "./MainLedgerCard1.vue?vue&type=template&id=fabb6cb8&scoped=true"
import script from "./MainLedgerCard1.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard1.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerCard1.vue?vue&type=style&index=0&id=fabb6cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabb6cb8",
  null
  
)

export default component.exports